import React, { ReactNode } from 'react';

interface SkeletonProps {
  className?: string;
  style?: React.CSSProperties;
  /** Lighter variant for blocks drawn over saturated gradient bands */
  onColor?: boolean;
}

/** A single shimmering placeholder block; size it with utility classes. */
export const Skeleton: React.FC<SkeletonProps> = ({ className = '', style, onColor }) => (
  <div
    aria-hidden="true"
    className={`ui-skeleton ${onColor ? 'ui-skeleton--on-color' : ''} ${className}`}
    style={style}
  />
);

/** Stack of text lines; the last one is shorter, like a real paragraph. */
export const SkeletonText: React.FC<{
  lines?: number;
  className?: string;
  lineClassName?: string;
  lastLineWidth?: string;
  onColor?: boolean;
}> = ({ lines = 3, className = '', lineClassName = 'h-4', lastLineWidth = '60%', onColor }) => (
  <div className={`space-y-2.5 ${className}`}>
    {Array.from({ length: lines }, (_, i) => (
      <Skeleton
        key={i}
        onColor={onColor}
        className={lineClassName}
        style={{ width: i === lines - 1 && lines > 1 ? lastLineWidth : '100%' }}
      />
    ))}
  </div>
);

/** Announces the loading state once to assistive tech and hides the placeholder blocks. */
export const SkeletonRegion: React.FC<{
  label?: string;
  className?: string;
  children: ReactNode;
}> = ({ label = 'Loading…', className = '', children }) => (
  <div role="status" aria-busy="true" aria-live="polite" className={className}>
    <span className="sr-only">{label}</span>
    {children}
  </div>
);
